import PageMeta from "../../components/common/PageMeta";
import AuthLayout from "./AuthPageLayout";
import ForgetPasswordForm from "../../components/auth/ForgetPasswordForm";

export default function ForgetPassword() {

    return (
        <>
            <PageMeta
                title="Recuperar Senha - Sellyo"
                description="Recupere sua senha"
            />
            <AuthLayout>
                <ForgetPasswordForm />
            </AuthLayout>
        </>
    );
}
